

































import Vue from 'vue';
import ModelOperation from '@/utils/modelOperation';
import * as api from '@/api';
import ProductToolbar from './ProductToolbar.vue';

export default Vue.extend({
    components: {
        ProductToolbar,
    },
    props: {
        is2D: {
            type: Boolean,
        },
        modelInfo: {
            type: Object,
        },
    },
    data() {
        return {
            isDrawing: false,
            radian: 0,
            setParams: {},
            toolbarItem: {},
            items: [
                {
                    modelGroupId: 'spdv012accfaee4cc02a8c15386542574de0',
                    bench: 0,
                    ModelOperation: {},
                    name: '约克公司',
                    groupName: '离心式冷水机组-格力.rfa',
                    modelPath: '',
                },
            ],
        };
    },
    created() {
        if (this.$store.state.user) this.$store.dispatch('getProductCompareList');
    },
    watch: {
        modelInfo(val) {
            if (!val.model || !val.model.path) return;
            this.items[0].modelPath = val.model.path;
            this.items[0].modelGroupId = val.modelGroupId;
            this.createModel();
        },
        compareProductList: {
            handler() {
                if (this.$route.name === 'Compare') {
                    if (this.is2D) {
                        this.getDrawings();
                    } else {
                        this.getModels();
                    }
                }
                this.isDrawing = this.is2D;
                this.$store.commit('modelLoadComplete', false);
            },
            immediate: true,
            deep: true,
        },
    },
    computed: {
        clickGroupIds(): string[] {
            return this.$store.state.clickGroupIds;
        },
        modelLoadComplete(): boolean {
            return this.$store.state.modelLoadComplete;
        },
        compareProductList(): any {
            return this.$store.state.compareProductList;
        },
    },
    methods: {
        async getModels() {
            const productIds = this.compareProductList.map((i) => i.productId).toString();
            if (productIds.length === 0) return;
            const res = await api.getModels({ productIds });
            if (!api.error(res)) {
                (this.items as any) = res.data;
                (this.items as any).forEach((e) => {
                    e.bench = 0;
                    e.ModelOperation = {};
                    e.modelPath = e.threeDModel;
                });
                this.createModel();
            }
        },
        async getDrawings() {
            const productIds = this.compareProductList.map((i) => i.productId).toString();
            if (productIds.length === 0) return;
            const res = await api.getDrawings({ productIds });
            if (!api.error(res)) {
                (this.items as any) = res.data;
                (this.items as any).forEach((e) => {
                    e.bench = 0;
                    e.ModelOperation = {};
                    e.modelPath = e.drawings;
                });
                this.createModel();
            }
        },
        createModel() {
            this.items.forEach((e, idx) => {
                if (!e.modelPath) return;
                const file = {
                    size: 122,
                };
                e.ModelOperation = new ModelOperation(file, e.modelGroupId);
                setTimeout(() => {
                    e.bench = (e.ModelOperation as any).createBench(e, this, `model${idx}`, !!this.isDrawing, idx);
                }, 20);
            });
        },
        together(item) {
            this.toolbarItem = item;
        },
        set(val) {
            this.setParams = val;
        },
        setRadian(val) {
            this.radian = val;
        },
        drawing(val) {
            if (this.modelInfo.drawings && this.modelInfo.drawings.path) {
                this.items[0].modelPath = val ? this.modelInfo.drawings.path : this.modelInfo.model.path;
                this.isDrawing = val;
                this.destroy();
                this.createModel();
            }
        },
        destroy() {
            this.items.forEach((e) => {
                setTimeout(() => {
                    e.modelPath && (e.ModelOperation as any).destroy(e.bench);
                }, 20);
            });
        },
    },
    destroyed() {
        this.destroy();
    },
});
